import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型找到你喜欢的韩漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${getCategoryIcon(cat.slug)} text-2xl text-foreground-600 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function getCategoryIcon(slug: string): string {
  const icons: Record<string, string> = {
    all: 'ri-apps-line',
    romance: 'ri-heart-line',
    fantasy: 'ri-magic-line',
    action: 'ri-sword-line',
    school: 'ri-building-line',
    mystery: 'ri-search-eye-line',
    historical: 'ri-ancient-gate-line',
    drama: 'ri-emotion-line',
    horror: 'ri-ghost-line',
    martial: 'ri-knife-line',
  };
  return icons[slug] || 'ri-book-read-line';
}